import { render, staticRenderFns } from "./detailFeedbackInstantClaim.vue?vue&type=template&id=01d7b40d&"
import script from "./detailFeedbackInstantClaim.vue?vue&type=script&lang=js&"
export * from "./detailFeedbackInstantClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports